function isMobileDevice() {
  return (
    typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1
  );
}

function isBannerVisible(banner) {
  return window.getComputedStyle(banner).display === 'flex';
}

function getAdData(banner) {
  const link = banner.querySelector('.promo-block-link');

  return {
    adSupplier: link?.dataset.adsupplier ?? '',
    adName: link?.dataset.adname ?? '',
  };
}

function pushDataLayerEvent(payload) {
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(payload);
}

export function initSponsoredBannersTracking() {
  const section = document.querySelector('.promotion-list-section');
  const banners = document.querySelectorAll('.sponsored-banners');

  if (!section || banners.length === 0) {
    return;
  }

  let isAdsBannerInView = false;
  let featuredItems = [];

  const handleIntersection = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !isAdsBannerInView) {
        isAdsBannerInView = true;
        pushDataLayerEvent({
          event: 'adImpression',
          adType: 'featured_banner',
          impressions: featuredItems,
        });
        observer.unobserve(entry.target);
      }
    });
  };

  const adObserver = new IntersectionObserver(handleIntersection, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  });

  adObserver.observe(section);

  window.addEventListener('load', () => {
    featuredItems = [];

    banners.forEach((banner) => {
      if (!isBannerVisible(banner)) {
        return;
      }

      const { adSupplier, adName } = getAdData(banner);

      // Replicate original swapped keys for analytics parity
      featuredItems.push({
        adname: adSupplier,
        adSupplier: adName,
      });
    });

    banners.forEach((banner) => {
      banner.addEventListener('click', () => {
        if (!isBannerVisible(banner)) {
          return;
        }

        const { adSupplier, adName } = getAdData(banner);
        pushDataLayerEvent({
          event: 'adClick',
          adType: 'featured_banner',
          adName,
          adSupplier,
        });
      });
    });

    if (isMobileDevice()) {
      const handleMobileAdIntersection = (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          const { adSupplier, adName } = getAdData(entry.target);
          pushDataLayerEvent({
            event: 'adClick',
            adType: 'featured_banner',
            adName,
            adSupplier,
          });
          observer.unobserve(entry.target);
        });
      };

      const mobileAdObserver = new IntersectionObserver(handleMobileAdIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      });

      banners.forEach((banner) => mobileAdObserver.observe(banner));
    }
  });
}
